var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M0 4.93103C0 3.38469 1.38312 1.94473 2.99598 1.81194L24.8854 0.00975001C26.3219 -0.108525 27.426 0.861783 27.4227 2.23964L27.3465 33.6529C27.343 35.112 26.1036 36.4928 24.577 36.7383L2.76374 40.246C1.2369 40.4915 0 39.5086 0 38.0497V4.93103Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M0 5.18126H28.5714C30.465 5.18126 32 6.62673 32 8.4098V41.7715C32 43.5545 30.465 45 28.5714 45H3.42857C1.53502 45 0 43.5545 0 41.7715V5.18126Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4286 9.04799C27.4286 8.45364 26.9169 7.97181 26.2857 7.97181H5.71429C5.0831 7.97181 4.57143 8.45364 4.57143 9.04799V13.3527C4.57143 13.9471 5.0831 14.4289 5.71429 14.4289L26.2857 14.4289C26.9169 14.4289 27.4286 13.9471 27.4286 13.3527V9.04799Z",
    fill: "#DFEBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8537 21.6194C16.777 22.0788 15.223 22.0788 14.1463 21.6194C13.2715 21.246 12.2929 21.2114 11.39 21.6026C9.48506 22.428 8.63041 24.8396 9.45882 27.0155C9.45917 27.0164 9.45934 27.0174 9.45933 27.0184L9.71812 27.5789C10.5929 29.4737 11.2523 31.4599 11.6841 33.5006L12.0947 35.4419C12.2368 35.9999 12.7391 36.3905 13.3145 36.3905C13.9326 36.3905 14.4593 35.9414 14.5574 35.3308L15.1363 31.7277C15.2045 31.3033 15.5705 30.9913 16 30.9913C16.4295 30.9913 16.7955 31.3033 16.8637 31.7277L17.4426 35.3308C17.5407 35.9414 18.0674 36.3905 18.6855 36.3905C19.2609 36.3905 19.7632 35.9999 19.9053 35.4419L20.3159 33.5006C20.7477 31.4599 21.4071 29.4737 22.2819 27.5789L22.5407 27.0184C22.5407 27.0174 22.5408 27.0164 22.5412 27.0155C23.3696 24.8396 22.5149 22.428 20.61 21.6026C19.7071 21.2114 18.7285 21.246 17.8537 21.6194Z",
    fill: "#DFEBFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooth);
export default __webpack_public_path__ + "static/media/iconTooth.92a0e0f039dc5814194fba3ebb1e9ad4.svg";
export { ForwardRef as ReactComponent };